export const CORPORATE_LOGIN_PATH = '/corporate-login'
export const CORPORATE_VERIFY_PATH = '/LoginVerify'
export const CORPORATE_UPLOAD_PATH = '/upload'

export const CORPORATE_PUBLIC_PATHS = [
  CORPORATE_LOGIN_PATH,
  CORPORATE_VERIFY_PATH,
] as const

export const CORPORATE_SIGNUP_PATHS = [
  '/',
  '/corporate',
  '/corporate-info',
  '/corporate-business-address',
  '/corporate-business-details',
  '/corporate-additional-details',
  '/corporate-date-details',
  '/corporate-documents',
  '/director-info',
  '/director-additional-info',
  '/director-pep-info',
  '/director-auth-info',
  '/director-personal-share',
  '/registration-complete',
  '/corporate-assist',
  '/corporate-article-incorporation',
] as const

export const ROUTES = {
  CORPORATE_INFO: '/corporate-info',
  CORPORATE_BUSINESS_ADDRESS: '/corporate-business-address',
  CORPORATE_BUSINESS_DETAILS: '/corporate-business-details',
  CORPORATE_ADDITIONAL_DETAILS: '/corporate-additional-details',
  CORPORATE_DATE_DETAILS: '/corporate',
  DIRECTOR_INFO: '/director-info',
  DIRECTOR_PEP_INFO: '/director-pep-info',
  CORPORATE_DOCUMENTS: '/corporate-documents',
  COMPLETE: '/registration-complete',
  DIRECTOR_AUTH_INFO: '/director-auth-info',
  CORPORATE_ASSIST: '/corporate-assist',
  CORPORATE_ARTICLE_INCORPORATION: '/corporate-article-incorporation',
  DIRECTOR_PERSONAL_SHARE: '/director-personal-share',
} as const
